import React from 'react'
import ReactMarkdown from 'react-markdown'
import { injectIntl, intlShape } from 'react-intl'
import Helmet from 'react-helmet';
import get from 'lodash/get';

import './ContentBlocks.css'

const FullbleedHero = (props) => (
  <div className="fullbleed hero" style={get(props, 'fields.image') ? {textShadow: 'black 0 0 5px', backgroundImage: 'url('+ get(props, 'fields.image.fields.file.url')+'?fm=jpg&q=80)'} : null}>
    <Helmet
      meta={[
        {"name": "description", "content": get(props, 'fields.lead')},
        {"property": "og:description", "content": get(props, 'fields.lead')}
      ]}
    />
    <div className="container">
      <div>
        {get(props, 'fields.heading') && <h1>{props.fields.heading}</h1>}

        {(get(props, 'fields.lead') && props.slug!=='reservation') && 
          <div className="lead">
            <ReactMarkdown source={get(props, 'fields.lead')} softBreak="br" />
          </div>
        }

        {
          (get(props, 'fields.ctaText') && (get(props, 'fields.ctaInternalLink') || get(props, 'fields.ctaExternalLink'))) && 
          <a href={get(props, 'fields.ctaInternalLink') ? get(props, 'fields.ctaInternalLink.fields.slug') : get(props, 'fields.ctaExternalLink')} className="btn">
            {get(props, 'fields.ctaText')}
          </a>
        }
      </div>
    </div>
  </div>
)

FullbleedHero.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(FullbleedHero)



// WEBPACK FOOTER //
// ./src/components/ContentBlocks/FullbleedHero.js